import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductPricingPlan.Clone.IRequest;
type Response = Api.Core.ProductPricingPlan.Clone.IResponse;
type Headers = Api.Core.ProductPricingPlan.Clone.IHeaders;
const url = '/api/ProductManagement/ProductPricingPlan/:fromId/Clone/:toId';
export default async function productPricingPlaCloneApi(params: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
